import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import * as examAndGradeAPI from "../../api/examAndGrade";

const initialState = {
  data: null,
  fileUrl: null,
  loading: false,
  studentMarksData: null,
  studentDetails: null,
  historySearch: {
    idDepartment: "",
    year: "",
    idSemester: "",
    months: "",
    limit: 10,
    offset: 0,
    institutionId: null,
  },
  recentFiles: [],
};

const uploadExamMarks = createAsyncThunk(
  "examAndGradeSlice/uploadExamMarks",
  async (params, { rejectWithValue }) => {
    try {
      const res = await examAndGradeAPI.uploadExamMarks(params.data);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return { res: res.data.body, file: params.file };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const downloadMarksTemplate = createAsyncThunk(
  "examAndGradeSlice/downloadMarksTemplate",
  async (params, { rejectWithValue }) => {
    try {
      const res = await examAndGradeAPI.downloadMarksTemplate(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStudentSubjectMarks = createAsyncThunk(
  "examAndGradeSlice/getStudentSubjectMarks",
  async (params, { rejectWithValue }) => {
    try {
      const res = await examAndGradeAPI.getStudentSubjectMarks(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getStudentDetails = createAsyncThunk(
  "examAndGradeSlice/getStudentDetails",
  async (params, { rejectWithValue }) => {
    try {
      const res = await examAndGradeAPI.getStudentDetails(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const UpdateSubjectMarks = createAsyncThunk(
  "examAndGradeSlice/UpdateSubjectMarks",
  async (params, { rejectWithValue }) => {
    try {
      const res = await examAndGradeAPI.UpdateSubjectMarks(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const examAndGradeSlice = createSlice({
  name: "examAndGradeSlice",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    resetUrl: (state) => {
      state.fileUrl = initialState.fileUrl;
    },
    setRecentFiles: (state, action) => {
      if (state.recentFiles.length >= 3) {
        state.recentFiles.pop();
      }
      state.recentFiles = [action.payload, ...state.recentFiles];
    },
    setHistorySearch: (state, { payload }) => {
      state.historySearch = payload;
    },
  },
  extraReducers: {
    [uploadExamMarks.pending]: (state) => {
      state.loading = true;
    },
    [uploadExamMarks.fulfilled]: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    [uploadExamMarks.rejected]: (state) => {
      state.loading = false;
    },
    [downloadMarksTemplate.pending]: (state) => {
      state.loading = true;
    },
    [downloadMarksTemplate.fulfilled]: (state, action) => {
      state.loading = false;
      state.fileUrl = action.payload;
    },
    [downloadMarksTemplate.rejected]: (state) => {
      state.loading = false;
    },

    [getStudentSubjectMarks.pending]: (state) => {
      state.loading = true;
    },
    [getStudentSubjectMarks.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentMarksData = action.payload;
    },
    [getStudentSubjectMarks.rejected]: (state) => {
      state.loading = false;
    },

    [getStudentDetails.pending]: (state) => {
      state.loading = true;
    },
    [getStudentDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.studentDetails = action.payload;
    },
    [getStudentDetails.rejected]: (state) => {
      state.loading = false;
    },

    [UpdateSubjectMarks.pending]: (state) => {
      state.loading = true;
    },
    [UpdateSubjectMarks.fulfilled]: (state, action) => {
      state.loading = false;
      toast.success(action.payload);
    },
    [UpdateSubjectMarks.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { resetState, resetUrl, setRecentFiles, setHistorySearch } =
  examAndGradeSlice.actions;

export default examAndGradeSlice.reducer;

export {
  resetState,
  uploadExamMarks,
  downloadMarksTemplate,
  resetUrl,
  getStudentSubjectMarks,
  getStudentDetails,
  UpdateSubjectMarks,
  setRecentFiles,
  setHistorySearch,
};
